import { formatUIDate } from 'utils/helpers'

//TODO add type definitions for the items
export const toTableRowItems = (items: any[]): any[] =>
  items.map(item => ({
    id: item.id,
    code: item.code ?? '',
    adAccount: item.adAccount ?? '',
    country: item.country?.name ?? '',
    name: item.name ?? '',
    legalEntityTypes: item.legalEntityTypes.map(type => type.name).join(', ') ?? '',
    activeAssignmentsCount: item.activeAssignmentsCount || 'No active assignments',
    storesCount: item.storeList?.length ?? 0,
    status: item.isEnabled ? { name: 'Enabled' } : { name: 'Disabled' }
  }))
